module.exports = __webpack_public_path__ + "consulting.3YGLxJWh.svg";